export const mapBooleanToBinaryString = (bool: boolean) => Number(bool).toString();
export const mapNumberToBoolean = (value?: string) => Boolean(Number(value));
export const mapBooleanToEnabledOrDisabled = (value?: boolean) => (value ? "enabled" : "disabled");
